import { useGetHasReadMutation } from "store/apis/infoModalsAPI"
import { INFO_MODAL_TYPE } from "store/apis/infoModalsAPI/types"
import { useModal } from "context/ModalsContext"

export const useCheckPolicy = () => {
  const { openModal } = useModal()
  const [getHasReadMutation] = useGetHasReadMutation()

  const checkTerms = async () => {
    const hasRead = await getHasReadMutation({
      type: INFO_MODAL_TYPE.TERMS,
      lang: "en"
    })

    return hasRead.data
  }

  // const checkPrivacy = async () => {
  //   const hasRead = await getHasReadMutation({
  //     type: INFO_MODAL_TYPE.POLICY,
  //     lang: "en",
  //   })

  //   return hasRead.data
  // }

  // const checkAML = async () => {
  //   const hasRead = await getHasReadMutation({
  //     type: INFO_MODAL_TYPE.AML,
  //     lang: "en",
  //   })

  //   return hasRead.data
  // }

  const checkPolicy = async () => {
    let isNewRead = false

    if (!(await checkTerms())) {
      isNewRead = true
      openModal({ type: "terms" })
    }

    // else if (!(await checkPrivacy())) {
    //   isNewRead = true
    //   openModal({ type: "privacy" })
    // } else if (!(await checkAML())) {
    //   isNewRead = true
    //   openModal({ type: "aml" })
    // }

    return isNewRead
  }

  return checkPolicy
}
